import { Location } from '@angular/common';
import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Optional,
    Output
} from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';
import { StudyPlanService } from 'app/main/services/studyPlans.service';
import { UtilsService } from 'app/main/services/utils.service';
import * as moment from 'moment';
import { LoaderService } from '../../services/loaderService.service';
import { LocalAccountService } from '../../services/localAccount.service';
import { CustomValidator } from '../../validators/custom-validators';

export class NewAvailability {
    degreeId: string;
    subjectId: string;
    startDate: number;
    endDate: number;
    monteOre: boolean;
    availabilities?: ItemAvailability[] = [];
    totalHours?: number;
    forProfessorCandidation?: boolean;
}

export class ItemAvailability {
    type: number;
    dayOfWeek: string;
    hours: HoursItem[];
}

export class HoursItem {
    startHour: string;
    endHour: string;
}

@Component({
    selector: 'app-agenda-availability-form',
    templateUrl: './agenda-availability-form.component.html',
    styleUrls: ['./agenda-availability-form.component.scss']
})
export class AgendaAvailabilityFormComponent implements OnInit {
    @Input() degreeCoursesAllowed: any[];
    @Input() inputAvailability: NewAvailability;
    @Input() inputNoDegreeCourseAndSubjectSelection: boolean;
    @Output() availabilitiesToSave: any;

    formInvalid: boolean;

    fromModal: boolean;

    availability: NewAvailability;
    subjectsAllowed: any[];
    noDegreeCourseAndSubjectSelection: boolean;

    form: FormGroup;
    showForm: boolean;
    showWeekSelection: boolean;

    daysOfWeek: any;
    days: any[];
    daysArray: any[];
    lastDaySelected: string;
    btnDisabled: boolean;
    groupGenerator: string;

    hoursOfDay: any[];
    hoursAssociative: any[];

    isProfessor: boolean;
    totalHours: number;

    tomorrow: any;
    disableTotalHours: boolean;
    showEndDate: boolean;

    subscription: any;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private loaderService: LoaderService,
        private utilsService: UtilsService,
        private studyPlanService: StudyPlanService,
        private location: Location,
        private localAccountService: LocalAccountService
    ) {
        this.formInvalid = true;
        this.showEndDate = false;
        this.availabilitiesToSave = new EventEmitter<any>();

        const today: Date = new Date();
        this.tomorrow = moment(today).add(1, 'days');

        this.hoursAssociative = [];
        this.daysArray = [];
        this.daysArray['MONDAY'] = 'Lunedì';
        this.daysArray['TUESDAY'] = 'Martedì';
        this.daysArray['WEDNESDAY'] = 'Mercoledì';
        this.daysArray['THURSDAY'] = 'Giovedì';
        this.daysArray['FRIDAY'] = 'Venerdì';
        this.daysArray['SATURDAY'] = 'Sabato';
        this.daysArray['SUNDAY'] = 'Domenica';

        // for select dayOfWeek
        this.daysOfWeek = [
            {
                value: 'MONDAY',
                label: this.daysArray['MONDAY']
            },
            {
                value: 'TUESDAY',
                label: this.daysArray['TUESDAY']
            },
            {
                value: 'WEDNESDAY',
                label: this.daysArray['WEDNESDAY']
            },
            {
                value: 'THURSDAY',
                label: this.daysArray['THURSDAY']
            },
            {
                value: 'FRIDAY',
                label: this.daysArray['FRIDAY']
            },
            {
                value: 'SATURDAY',
                label: this.daysArray['SATURDAY']
            },
            {
                value: 'SUNDAY',
                label: this.daysArray['SUNDAY']
            }
        ];

        // array for select startHour && endHour
        this.hoursOfDay = [
            '00:00',
            '01:00',
            '02:00',
            '03:00',
            '04:00',
            '05:00',
            '06:00',
            '07:00',
            '08:00',
            '09:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00',
            '24:00'
        ];

        this.subjectsAllowed = [];
        this.days = [];
    }

    async ngOnInit() {
        if (this.data && this.data.availability) {
            this.availability = this.data.availability;
            this.degreeCoursesAllowed = this.data.degreeCoursesAllowed;
            this.noDegreeCourseAndSubjectSelection = this.data.noDegreeCourseAndSubjectSelection;
            if (this.availability.forProfessorCandidation) {
                this.setDegree(this.availability.degreeId);
            }
            if (this.data.totalHours) {
                this.disableTotalHours = true;
                this.availability.totalHours = this.data.totalHours;
            } else {
                this.disableTotalHours = false;
            }
            if (this.data.subscription) {
                this.subscription = this.data.subscription;
                if (!this.subscription.color) {
                    this.subscription.color = '#3c4252';
                }
            }
            this.fromModal = true;
        }
        if (!this.availability || !this.fromModal) {
            if (!this.inputAvailability) {
                this.inputAvailability = new NewAvailability();
            }
            this.availability = this.inputAvailability;
            this.fromModal = false;
        }
        this.isProfessor = this.localAccountService.isProfessor();
        if (this.isProfessor) {
            this.disableTotalHours = false;
            this.showWeekSelection = true;
            this.showEndDate = true;
        }
        this.buildForm();
    }

    buildForm() {
        let monteOre = false;
        let disabled = false;
        let totalHours = null;
        if (!this.isProfessor) {
            monteOre = true;
            disabled = true;
        } else if (this.isProfessor) {
            monteOre = null;
            disabled = false;
        }
        if (this.availability) {
            if (this.availability.totalHours) {
                totalHours = this.availability.totalHours;
            }
        }

        const objForm: any = {
            degreeId: new FormControl(
                this.availability.degreeId,
                Validators.required
            ),
            subjectId: new FormControl(
                this.availability.subjectId,
                Validators.required
            ),
            startDate: new FormControl(
                this.availability.startDate,
                Validators.compose([
                    Validators.required,
                    CustomValidator.startValidator,
                    CustomValidator.compareValidator
                ])
            ),
            endDate: new FormControl(
                this.availability.endDate,
                Validators.compose([
                    Validators.required,
                    CustomValidator.endValidator,
                    CustomValidator.compareValidator
                ])
            ),
            monteOre: new FormControl(monteOre, null),
            totalHours: new FormControl(
                totalHours,
                Validators.compose([
                    Validators.required,
                    CustomValidator.monteOreValidator
                ])
            ),
            availabilities: new FormArray([], null)
        };
        if (this.isProfessor) {
            objForm.totalHours = null;
            objForm.availabilities = new FormArray(
                [],
                Validators.compose([Validators.required])
            );
        }
        this.form = this.fb.group(objForm);
        this.form.controls['totalHours'].setValue(totalHours);
        if (!this.isProfessor) {
            this.form.controls['endDate'].setValidators(null);
            this.form.controls['endDate'].disable();
        }
        if (this.availability.forProfessorCandidation) {
            this.form.controls.degreeId.disable();
            this.form.controls.subjectId.disable();
        }
        this.showForm = true;
    }

    get baseForm() {
        return this.form.controls;
    }
    get availabilities() {
        return this.form.controls.availabilities as FormArray;
    }

    setDisableBtn(j, form) {
        if (j > 0) {
            return false;
        } else {
            if (form.length === 1) {
                return true;
            } else {
                return false;
            }
        }
    }

    removeHourGroup(e, i, j) {
        e.preventDefault();
        e.stopPropagation();
        const group = this.availabilities.controls[i] as FormGroup;
        const arr = group.controls.hours as FormArray;
        const c = this.hoursAssociative[this.availabilities.value[i].dayOfWeek]
            .associativeArray[arr.value[j].startHour];
        if (c) {
            c.disabled = false;
        }
        this.checkIntervalRemove(
            this.availabilities.value[i].dayOfWeek,
            arr.value[j].startHour,
            arr.value[j].endHour
        );
        arr.removeAt(j);
    }

    /* buildFormGroupAvailabilities() {
    const form = this.fb.group({
      dayOfWeek: new FormControl(null, Validators.required),
      type: new FormControl(null, Validators.required),
      hours: new FormArray([this.buildFormGroupHours()], Validators.required)
    });
    return form;
  } */

    buildFormGroupHours() {
        const form = this.fb.group({
            startHour: new FormControl(
                null,
                Validators.compose([
                    Validators.required,
                    CustomValidator.hourValidation
                ])
            ),
            endHours: new FormControl(
                null,
                Validators.compose([
                    Validators.required,
                    CustomValidator.hourValidation
                ])
            )
        });
        return form;
    }

    async setDegree(degreeId) {
        this.loaderService.showLoader();
        await this.getAllowedSubjectsByDegreeCourseId(degreeId).finally(() => {
            this.loaderService.hideLoader();
        });
    }

    async getAllowedSubjectsByDegreeCourseId(degreeCourseId) {
        this.subjectsAllowed = [];
        const resp: any = await this.studyPlanService
            .getAllowedSubjectsByDegreeCourseId(degreeCourseId)
            .catch(err => {
                console.error(err);
            });
        if (resp && resp.ok) {
            this.subjectsAllowed = resp.payload;
        }
    }

    toggleWeek(e) {
        if (!e.checked) {
            this.showWeekSelection = true;
            this.days = [];
            this.form.addControl(
                'availabilities',
                new FormArray([], Validators.compose([Validators.required]))
            );
            this.form.removeControl('totalHours');
        } else {
            this.showWeekSelection = false;
            let totalHour: number = null;
            let disabled = false;
            if (this.availability) {
                if (this.availability.totalHours) {
                    totalHour = this.availability.totalHours;
                    if (!this.isProfessor) {
                        disabled = true;
                    }
                    totalHour = this.availability.totalHours;
                }
            }
            this.form.addControl(
                'totalHours',
                new FormControl(
                    totalHour,
                    Validators.compose([
                        Validators.required,
                        CustomValidator.monteOreValidator
                    ])
                )
            );
            this.form.controls['totalHours'].setValue(totalHour);
            this.hoursAssociative = [];
        }
    }

    setDayOnAssociativeArray(event, value) {
        event.preventDefault();
        event.stopPropagation();
        if (value) {
            const day = value;
            if (this.days[day.value]) {
                this.utilsService.newWarningSnackbar(`Giorno già selezionato`);
                return;
            } else {
                this.lastDaySelected = day;
                this.days[day.value] = day.value;
                this.addAvailabilitiesGroup(value);
                this.groupGenerator = null;
            }
        } else {
            this.utilsService.newWarningSnackbar(`Nessun giorno selezionato`);
        }
    }

    addAvailabilitiesGroup(day) {
        this.availabilities.push(
            this.fb.group({
                dayOfWeek: new FormControl(day.value, Validators.required),
                dayOfWeekReadable: new FormControl(day.label, null),
                type: new FormControl(null, Validators.required),
                hours: new FormArray([])
            })
        );
    }

    deleteAvailabilities(e, i) {
        e.preventDefault();
        e.stopPropagation();
        const day = this.availabilities.value[i].dayOfWeek;
        delete this.days[day];
        this.availabilities.removeAt(i);
        this.form.updateValueAndValidity();
    }

    setFormInvalid() {
        let ret;
        if (
            this.form.invalid ||
            (this.availabilities &&
                (this.availabilities.length === 0 &&
                    !this.form.getRawValue().monteOre))
        ) {
            ret = true;
        } else {
            ret = false;
        }
        this.formInvalid = ret;
        return ret;
    }

    addHourGroup(e, i) {
        e.preventDefault();
        e.stopPropagation();

        const group = this.availabilities.controls[i] as FormGroup;
        const arr = group.controls.hours as FormArray;

        if (arr.status === 'VALID') {
            if (arr.length > 0) {
                for (let ih = 0; ih < arr.length; ih++) {
                    this.hoursAssociative[
                        this.availabilities.value[i].dayOfWeek
                    ].associativeArray[arr.value[ih].startHour].disabled = true;
                    // this.hoursAssociative[this.availabilities.value[i].dayOfWeek].associativeArray[arr.value[ih].endHour].disabled = true;
                    this.checkIntervalAdd(
                        this.availabilities.value[i].dayOfWeek,
                        arr.value[ih].startHour,
                        arr.value[ih].endHour
                    );
                }
            }
            arr.push(
                this.fb.group({
                    startHour: new FormControl(
                        null,
                        Validators.compose([
                            Validators.required,
                            CustomValidator.hourValidation
                        ])
                    ),
                    endHour: new FormControl(
                        null,
                        Validators.compose([
                            Validators.required,
                            CustomValidator.hourValidation
                        ])
                    )
                })
            );
        } else {
            this.utilsService.newWarningSnackbar(
                `Nessun intervallo selezionato`
            );
            return;
        }
    }

    checkIntervalAdd(day, start, end) {
        const nStart: number = this.hoursAssociative[day].associativeArray[
            start
        ].number;
        const nEnd: number = this.hoursAssociative[day].associativeArray[end]
            .number;
        if (nStart < nEnd) {
            // tslint:disable-next-line:forin
            for (const key in this.hoursAssociative[day].associativeArray) {
                const value = this.hoursAssociative[day].associativeArray[key];
                if (value.number > nStart && value.number < nEnd) {
                    value.disabled = true;
                }
            }
        }
    }

    checkIntervalRemove(day, start, end) {
        if (start && end) {
            const nStart: number = this.hoursAssociative[day].associativeArray[
                start
            ].number;
            const nEnd: number = this.hoursAssociative[day].associativeArray[
                end
            ].number;
            if (nStart < nEnd) {
                // tslint:disable-next-line:forin
                for (const key in this.hoursAssociative[day].associativeArray) {
                    const value = this.hoursAssociative[day].associativeArray[
                        key
                    ];
                    if (value.number > nStart && value.number < nEnd) {
                        value.disabled = false;
                    }
                }
            }
        }
    }

    newAssociativeArray() {
        const arr: any = [];
        arr['00:00'] = { value: '00:00', number: 0, disabled: false };
        arr['01:00'] = { value: '01:00', number: 1, disabled: false };
        arr['02:00'] = { value: '02:00', number: 2, disabled: false };
        arr['03:00'] = { value: '03:00', number: 3, disabled: false };
        arr['04:00'] = { value: '04:00', number: 4, disabled: false };
        arr['05:00'] = { value: '05:00', number: 5, disabled: false };
        arr['06:00'] = { value: '06:00', number: 6, disabled: false };
        arr['07:00'] = { value: '07:00', number: 7, disabled: false };
        arr['08:00'] = { value: '08:00', number: 8, disabled: false };
        arr['09:00'] = { value: '09:00', number: 9, disabled: false };
        arr['10:00'] = { value: '10:00', number: 10, disabled: false };
        arr['11:00'] = { value: '11:00', number: 11, disabled: false };
        arr['12:00'] = { value: '12:00', number: 12, disabled: false };
        arr['13:00'] = { value: '13:00', number: 13, disabled: false };
        arr['14:00'] = { value: '14:00', number: 14, disabled: false };
        arr['15:00'] = { value: '15:00', number: 15, disabled: false };
        arr['16:00'] = { value: '16:00', number: 16, disabled: false };
        arr['17:00'] = { value: '17:00', number: 17, disabled: false };
        arr['18:00'] = { value: '18:00', number: 18, disabled: false };
        arr['19:00'] = { value: '19:00', number: 19, disabled: false };
        arr['20:00'] = { value: '20:00', number: 20, disabled: false };
        arr['21:00'] = { value: '21:00', number: 21, disabled: false };
        arr['22:00'] = { value: '22:00', number: 22, disabled: false };
        arr['23:00'] = { value: '23:00', number: 23, disabled: false };
        arr['24:00'] = { value: '24:00', number: 24, disabled: false };

        return arr;
    }

    back() {
        if (this.fromModal) {
            this.data.closeModal(null);
        } else {
            this.location.back(); // viene fruito sempre in modale
        }
    }

    setHourArray(e, i) {
        if (this.availabilities.value[i].type) {
            if (this.availabilities.value[i].type === '3') {
                const group = this.availabilities.controls[i] as FormGroup;
                const arr = group.controls.hours as FormArray;
                const obj: any = {
                    day: this.availabilities.value[i].dayOfWeek,
                    // h: [],
                    associativeArray: this.newAssociativeArray()
                };
                this.hoursAssociative[obj.day] = obj;
                while (arr.length !== 0) {
                    arr.removeAt(0);
                }
                arr.push(
                    this.fb.group({
                        startHour: new FormControl(
                            null,
                            Validators.compose([
                                Validators.required,
                                CustomValidator.hourValidation
                            ])
                        ),
                        endHour: new FormControl(
                            null,
                            Validators.compose([
                                Validators.required,
                                CustomValidator.hourValidation
                            ])
                        )
                    })
                );
            } else {
                if (this.availabilities.value[i].type === '0') {
                    const group = this.availabilities.controls[i] as FormGroup;
                    const arr = group.controls.hours as FormArray;
                    while (arr.length !== 0) {
                        arr.removeAt(0);
                    }
                    arr.push(
                        this.fb.group({
                            startHour: new FormControl(
                                '09:00',
                                Validators.compose([
                                    Validators.required,
                                    CustomValidator.hourValidation
                                ])
                            ),
                            endHour: new FormControl(
                                '13:00',
                                Validators.compose([
                                    Validators.required,
                                    CustomValidator.hourValidation
                                ])
                            )
                        })
                    );
                    arr.push(
                        this.fb.group({
                            startHour: new FormControl(
                                '14:00',
                                Validators.compose([
                                    Validators.required,
                                    CustomValidator.hourValidation
                                ])
                            ),
                            endHour: new FormControl(
                                '18:00',
                                Validators.compose([
                                    Validators.required,
                                    CustomValidator.hourValidation
                                ])
                            )
                        })
                    );
                } else if (this.availabilities.value[i].type === '1') {
                    const group = this.availabilities.controls[i] as FormGroup;
                    const arr = group.controls.hours as FormArray;
                    while (arr.length !== 0) {
                        arr.removeAt(0);
                    }
                    arr.push(
                        this.fb.group({
                            startHour: new FormControl(
                                '09:00',
                                Validators.compose([
                                    Validators.required,
                                    CustomValidator.hourValidation
                                ])
                            ),
                            endHour: new FormControl(
                                '13:00',
                                Validators.compose([
                                    Validators.required,
                                    CustomValidator.hourValidation
                                ])
                            )
                        })
                    );
                } else if (this.availabilities.value[i].type === '2') {
                    const group = this.availabilities.controls[i] as FormGroup;
                    const arr = group.controls.hours as FormArray;
                    while (arr.length !== 0) {
                        arr.removeAt(0);
                    }
                    arr.push(
                        this.fb.group({
                            startHour: new FormControl(
                                '14:00',
                                Validators.compose([
                                    Validators.required,
                                    CustomValidator.hourValidation
                                ])
                            ),
                            endHour: new FormControl(
                                '18:00',
                                Validators.compose([
                                    Validators.required,
                                    CustomValidator.hourValidation
                                ])
                            )
                        })
                    );
                }
            }
        }
    }

    validateDateInterval() {
        const val = this.form.getRawValue();
        if (val.startDate && val.endDate) {
            if (
                moment(val.startDate).valueOf() < moment(val.endDate).valueOf()
            ) {
                this.form.controls['startDate'].updateValueAndValidity();
                this.form.controls['endDate'].updateValueAndValidity();
            }
        }
    }

    submitForm() {
        if (this.formInvalid) {
            return;
        }
        const value = this.form.getRawValue();
        value.startDate = moment(value.startDate).valueOf();
        value.endDate = moment(value.endDate).valueOf();
        if (this.fromModal) {
            this.data.closeModal(value);
        } else {
            this.availabilitiesToSave.emit(value);
        }
    }

    validateHourInterval(i, form) {
        const val = form.value;
        // tslint:disable-next-line:radix
        const valueStartHour = parseInt(val.startHour);
        // tslint:disable-next-line:radix
        const valueEndHour = parseInt(val.endHour);
        if (val.startHour && val.endHour) {
            // tslint:disable-next-line:max-line-length
            const isInvalidInterval: boolean = this.checkIfIntervalIsInvalid(
                this.hoursAssociative[this.availabilities.value[i].dayOfWeek]
                    .associativeArray,
                valueStartHour,
                valueEndHour
            );
            if (!isInvalidInterval) {
                const nowHour = new Date().getHours();
                if (valueStartHour <= nowHour) {
                    form.controls['startHour'].setErrors({
                        incorrect: false,
                        incorrect2: true
                    });
                } else {
                    if (valueStartHour < valueEndHour) {
                        form.controls['startHour'].updateValueAndValidity();
                        form.controls['endHour'].updateValueAndValidity();
                    }
                }
            } else {
                form.controls['startHour'].setErrors({
                    incorrect: true,
                    incorrect2: false
                });
                form.controls['endHour'].setErrors({
                    incorrect: true,
                    incorrect2: false
                });
            }
        }
    }

    checkIfIntervalIsInvalid(array, start, end) {
        if ((start || start === 0) && (end || end === 0)) {
            if (start === end) {
                return true;
            } else {
                // tslint:disable-next-line:forin
                for (const key in array) {
                    const value = array[key];
                    if (
                        value.number >= start &&
                        value.number < end &&
                        value.disabled
                    ) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}
